import { Input, Select } from "@touche-lts/panel-ui/dist";
import { observer } from "mobx-react-lite";
import { useRootStore } from "mobx-stores/store-provider";
import { useState } from "react";
import styles from "../header.module.scss";

const SearchComponent = () => {
  const {
    routingStore: { push },
    generalStore: {
      api: {
        searchApi: { globalSearch },
      },
    },
  } = useRootStore();

  const [querySearch, setQuerySearch] = useState<string>("");
  const [result, setResult] = useState(null);
  const [selectedSearchCriteria, setSelectedSearchCriteria] = useState("");
  let totalResult: number;

  const handleGlobalSearch = (query) => {
    if (query === "") {
      setResult(null);
    }

    setQuerySearch(() => query);

    globalSearch(querySearch)
      .then((res) => setResult(res))
      .catch((e) => {
        console.log(e);
      });
  };

  const handleOptions = () => {
    return [
      { label: "Everywhere", value: "Everywhere" },
      { label: "Stores", value: "store" },
      { label: "Departments", value: "department" },
      { label: "Products", value: "product" },
    ];
  };

  const handleSearchSelected = (value) => {
    setSelectedSearchCriteria(value);
    console.log(value);
  };

  const handleRoute = (type, id) => {
    console.log(type);

    switch (type) {
      case "store": {
        push(`/stores/${id}`);
        setQuerySearch(null);
        setResult(null);
        break;
      }
      case "product": {
        push(`/product/${id}`);
        setQuerySearch(null);
        setResult(null);
        break;
      }
      case "department": {
        push(`/departments/${id}`);
        setQuerySearch(null);
        setResult(null);
        break;
      }
      default: {
        break;
      }
    }
  };

  const renderSearchElements = (e) => {
    return (
      <div
        className={styles.searchResult}
        key={e.typeId}
        onClick={() => handleRoute(e.type, e.typeId)}
      >
        <span>
          <div>
            <img src={`${e.img}`} alt="" />
          </div>
          <p>{e.type}</p>
          <div>{e.name}</div>
        </span>
      </div>
    );
  };

  return (
    <p className={styles.searchContainer}>
      <Select
        colorPreset="dark"
        options={handleOptions()}
        value={selectedSearchCriteria}
        noneLabel="Select Search"
        key={""}
        onChange={(value) => handleSearchSelected(value)}
        containerClassName={styles.select}
      />
      <p className={styles.search}>
        <Input
          colorPreset="dark"
          placeholder="Search for anything..."
          value={querySearch}
          onChange={(query) => handleGlobalSearch(query)}
          className={styles.searchInput}
        />
        {result && (
          <div
            style={{
              position: "absolute",
              top: "100%",
              left: 0,
              width: "100%",
              zIndex: 1999,
            }}
          >
            <div className={styles.dropdown}>
              {result.map((r) => {
                if (querySearch === "") {
                  return null;
                }
                totalResult += r.length;
                return (
                  <>
                    {r.map((e) => {
                      totalResult += e.length;
                      if (selectedSearchCriteria === "Everywhere") {
                        return renderSearchElements(e);
                      }
                      if (selectedSearchCriteria === e.type) {
                        return renderSearchElements(e);
                      }
                    })}
                  </>
                );
              })}
            </div>
            <div style={{ marginTop: "10px" }}>
              <p>Total Results: {totalResult}</p>
            </div>
          </div>
        )}
      </p>
    </p>
  );
};

const Search = observer(SearchComponent);

export { Search };
